import { Quote } from 'lucide-react';
import { Reveal } from './Reveal';

const TESTIMONIALS = [
  { img: '/assets/av-1.webp', name: 'Rafael M.', age: 27, text: 'Eu vivia começando e parando. No dia 10 da jornada, acordar cedo já era automático.' },
  { img: '/assets/av-2.webp', name: 'Camila S.', age: 31, text: 'O rastreador de hábitos me mostrou que disciplina é repetição, não motivação.' },
  { img: '/assets/av-3.webp', name: 'Diego A.', age: 24, text: 'Os desafios diários me tiraram do celular à noite. Meu foco no trabalho mudou em duas semanas.' },
  { img: '/assets/av-4.webp', name: 'Juliana R.', age: 29, text: 'As frases e os versículos diários viraram meu ritual da manhã. Nunca fui tão constante.' },
  { img: '/assets/av-5.webp', name: 'Lucas T.', age: 34, text: 'Ver o progresso acumulado me impediu de desistir no dia mais difícil. Vale cada dia.' },
  { img: '/assets/av-6.webp', name: 'Mariana F.', age: 26, text: 'É simples: abrir, marcar, evoluir. Em 28 dias a minha rotina era outra.' },
];

const Card = ({ t, i }) => (
  <figure
    data-testid={`testimonial-card-${i}`}
    className="w-[290px] shrink-0 rounded-2xl border border-white/[0.07] bg-graphite p-6 transition-colors duration-300 hover:border-gold/40 sm:w-[320px]"
  >
    <Quote className="h-5 w-5 text-gold/70" strokeWidth={1.8} />
    <blockquote className="mt-4 min-h-[84px] text-sm leading-relaxed text-neutral-300">“{t.text}”</blockquote>
    <figcaption className="mt-5 flex items-center gap-3 border-t border-white/5 pt-4">
      <img src={t.img} alt={`Foto de ${t.name}`} loading="lazy" className="h-11 w-11 rounded-full border border-gold/25 object-cover" />
      <div>
        <p className="text-sm font-semibold text-white">{t.name}</p>
        <p className="font-accent text-[10px] tracking-[0.2em] uppercase text-neutral-500">{t.age} anos · aluno(a)</p>
      </div>
    </figcaption>
  </figure>
);

export const Testimonials = () => (
  <section data-testid="testimonials-section" className="relative overflow-hidden border-t border-white/5">
    <div className="pointer-events-none absolute left-1/2 top-0 -z-10 h-[300px] w-[600px] -translate-x-1/2 rounded-full bg-gold/[0.05] blur-[120px]" />
    <div className="mx-auto max-w-6xl px-6 pt-24 sm:px-10 sm:pt-32">
      <Reveal>
        <p className="mb-4 flex items-center gap-3 font-accent text-[11px] tracking-[0.35em] uppercase text-gold">
          <span className="h-px w-10 bg-gold/60" />
          Quem já começou
        </p>
        <h2 className="max-w-2xl font-display text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
          Resultados de quem <span className="text-gold">despertou.</span>
        </h2>
      </Reveal>
    </div>

    <Reveal delay={0.15} className="mt-14 pb-24 sm:pb-32">
      <div className="group relative">
        <div className="animate-marquee flex w-max gap-5 pl-6 group-hover:[animation-play-state:paused]">
          {[...TESTIMONIALS, ...TESTIMONIALS].map((t, i) => (
            <Card key={`${t.name}-${i}`} t={t} i={(i % TESTIMONIALS.length) + 1} />
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-20 bg-gradient-to-r from-[#030303] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-20 bg-gradient-to-l from-[#030303] to-transparent" />
      </div>
    </Reveal>
  </section>
);
